import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, FormGroupDirective} from "@angular/forms";

@Component({
  selector: 'ebw-monorepo-dynamic-error',
  templateUrl: './dynamic-error.component.html',
  styleUrls: ['./dynamic-error.component.scss']
})
export class DynamicErrorComponent implements OnInit {
  @Input() fieldName: string;
  formName: FormGroup;
  constructor(private formGroupDirective: FormGroupDirective) {}
  ngOnInit(): void {
    this.formName = this.formGroupDirective.control
  }
}
